import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SimplyReliable from "./sections/SimplyReliable";
import ProductCategories from "./sections/ProductCategories";
import TrendingProblemSolvers from "./sections/TrendingProblemSolvers";
import SafetyQualityStandards from "./sections/SafetyQualityStandards";
import WellnessInsights from "./sections/WellnessInsights";
import MarketplaceFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SimplyReliable />
      <ProductCategories />
      <TrendingProblemSolvers />
      <SafetyQualityStandards />
      <WellnessInsights />
      <MarketplaceFooter />
    </div>;
}